export const currentLocations = [
    {
        id: 1,
        browser: "Chrome",
        operatingSystem: "Windows",
        approximateLocation: "119.73.97.168",
        lastSignedIn: "12/29/2022 9:00 pm"
    },
    {
        id: 2,
        browser: "Chrome",
        operatingSystem: "Windows",
        approximateLocation: "119.73.97.168",
        lastSignedIn: "12/29/2022 9:00 pm"
    },
    {
        id: 3,
        browser: "Chrome",
        operatingSystem: "Windows",
        approximateLocation: "119.73.97.168",
        lastSignedIn: "12/29/2022 9:00 pm"
    },
    {
        id: 4,
        browser: "Chrome",
        operatingSystem: "Windows",
        approximateLocation: "119.73.97.168",
        lastSignedIn: "12/29/2022 9:00 pm"
    },
    {
        id: 5,
        browser: "Chrome",
        operatingSystem: "Windows",
        approximateLocation: "119.73.97.168",
        lastSignedIn: "12/29/2022 9:00 pm"
    },
    {
        id: 6,
        browser: "Chrome",
        operatingSystem: "Windows",
        approximateLocation: "119.73.97.168",
        lastSignedIn: "12/29/2022 9:00 pm"
    },
    {
        id: 7,
        browser: "Chrome",
        operatingSystem: "Windows",
        approximateLocation: "119.73.97.168",
        lastSignedIn: "12/29/2022 9:00 pm"
    },
    {
        id: 8,
        browser: "Chrome",
        operatingSystem: "Windows",
        approximateLocation: "119.73.97.168",
        lastSignedIn: "12/29/2022 9:00 pm"
    },
    {
        id: 9,
        browser: "Chrome",
        operatingSystem: "Windows",
        approximateLocation: "119.73.97.168",
        lastSignedIn: "12/29/2022 9:00 pm"
    },
    {
        id: 10,
        browser: "Chrome",
        operatingSystem: "Windows",
        approximateLocation: "119.73.97.168",
        lastSignedIn: "12/29/2022 9:00 pm"
    },
];